import { render, staticRenderFns } from "./PostCommentField.vue?vue&type=template&id=0316cf0c&scoped=true&"
import script from "./PostCommentField.vue?vue&type=script&lang=ts&"
export * from "./PostCommentField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0316cf0c",
  null
  
)

export default component.exports